import moment from "moment";
export const trimAddress = (addr) => {
  return `${addr.substring(0, 6)}...${addr.substring(addr.length - 4)}`;
}


export const contract = {
  56: {
    // STAKE_ADDRESS: "0x69fe8c1cc8fcbcdde01a602dc42307e85504e46b",
    // MULTICALL_ADDRESS: "0xa54fE4a3DbD1Eb21524Cd73754666b7E13b4cB18"
    STAKE_ADDRESS: "0x538ba2f57a65708f399700902b51c466c54ab6c6",
    MULTICALL_ADDRESS: "0x2cc8fe3e04d7b1edaeb42e2e73f78c4cac074116"
  }
}

export const DEFAULT_CHAIN = 56;
export const DEFAULT_RPC = "https://bsc-dataseed1.binance.org/"
// export const DEFAULT_RPC = "https://data-seed-prebsc-2-s1.binance.org:8545/"
export const PROJECT_ID = "27b9720018bf7f8740936e6a6eb28604";
export const DECIMALS = 18;
export const EXPLOER = 'https://bscscan.com/';
export const UPTOAPY = 60;

export const formatDateWithZone = (unixTime) =>{
  try{
    let dateString = new Date(unixTime).toString();
   
    let startIndex = dateString.indexOf("(");
    let modifyDate = dateString.substring(0,startIndex);
    return modifyDate;
  }
  catch(err){
    console.log(err.message);
  }
  
}

export const formatDate = (unixTime) =>{
  try{
    let dateString = moment(unixTime).format('lll');
    return dateString;
  }
  catch(err){
    console.log(err.message);
  }
  
}

export const APY = [
  {
    duration : '1 Year',
    apy : 20,
    time : 8760
  },
  {
    duration : '2 Year',
    apy : 30,
    time : 17520
  },
  {
    duration : '3 Year',
    apy : 40,
    time : 26280
  },
  {
    duration : '4 Year',
    apy : 50,
    time : 35040
  },
  {
    duration : '5 Year',
    apy : 60,
    time : 43800
  }
]